export default "__VITE_ASSET__BwYITeOu__"